<template>
  <v-menu
    v-model="menu"
    ref="menu"
    :close-on-content-click="false"
    class="year-picker-menu"
    content-class="year-picker-menu-content"
    full-width
    allow-overflow
    min-width="290px"
    offset-y
    bottom
    left
    origin="top right"
    :disabled="disabled"
    >
    <v-text-field
      slot="activator"
      :value="year"
      @keydown="onTextFieldKeyDown"
      @change="onTextFieldChange"
      v-bind="textFieldAttrs"
    ></v-text-field>
    <v-date-picker
      ref="datepicker"
      v-model="date"
      @input="onDatePickerInput"
      reactive
      class="year-picker"
      v-bind="datePickerAttrs"></v-date-picker>
  </v-menu>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      menu: false,
      year: this.value
    }
  },
  computed: {
    date: {
      get () {
        let y = this.year
        let d = new Date(Date.UTC(y, 0))
        return d.toISOString().substring(0, 10)
      },
      set (v) {
        let d = new Date(v)
        let y = d.getFullYear()
        this.year = y
      }
    },
    textFieldAttrs () {
      let attrs = this.$attrs
      let skipAttrs = ['value', 'clear-icon', 'clearable', 'counter', 'mask', 'type']
      let textFieldAttrs = this.filterAttrs(attrs, 'text-field-', skipAttrs)
      return textFieldAttrs
    },
    datePickerAttrs () {
      let attrs = this.$attrs
      let skipAttrs = ['value', 'reactive', 'type']
      let datePickerAttrs = this.filterAttrs(attrs, 'date-picker-', skipAttrs)
      return datePickerAttrs
    }
  },
  watch: {
    value (val) {
      this.year = val
    },
    menu (val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.datepicker.activePicker = 'YEAR'
          this.scrolltoSelectedYear()
        })
      }
    },
    year (val) {
      this.$emit('input', val)
    }
  },
  methods: {
    filterAttrs (attrs, prefix, disallowedAttrs) {
      let keys = Object.keys(attrs).filter(x => x.toLowerCase().indexOf(prefix) === 0)
      let result = {}
      keys.forEach(key => {
        let tfkey = key.replace(prefix, '').toLowerCase()
        if (disallowedAttrs.indexOf(tfkey) < 0) {
          result[tfkey] = attrs[key]
        }
      })

      return result
    },
    onDatePickerInput (date) {
      this.$refs.menu.save(date)
      this.$refs.datepicker.activePicker = 'YEAR'
      this.menu = false
    },
    findYearPicker (node) {
      if (node == null) {
        return null
      }
      let name = (node.$options || {}).name
      if (name === 'v-date-picker-years') {
        return node
      }
      let children = node.$children || []
      let result = null
      for (let i = 0; i < children.length; i++) {
        let childResult = this.findYearPicker(children[i])
        if (childResult != null) {
          result = childResult
          break
        }
      }
      return result
    },
    scrolltoSelectedYear () {
      setTimeout(() => {
        let yearPicker = this.findYearPicker(this.$refs.datepicker)
        if (yearPicker != null) {
          let yearPickerEl = yearPicker.$el
          const activeItem = yearPickerEl.getElementsByClassName('active')[0]
          if (activeItem) {
            yearPickerEl.scrollTop = activeItem.offsetTop - yearPickerEl.offsetHeight / 2 + activeItem.offsetHeight / 2
          } else {
            yearPickerEl.scrollTop = yearPickerEl.scrollHeight / 2 - yearPickerEl.offsetHeight / 2
          }
        }
      }, 100)
    },
    onTextFieldKeyDown (e) {
      let key = e.key
      let allowedKeys = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'Tab', 'Del', 'Delete', 'Backspace', 'ArrowLeft', 'Left', 'ArrowRight', 'Right']
      if (allowedKeys.indexOf(key) < 0 && !((key === 'v' || key === 'a' || key === 'c') && e.ctrlKey)) {
        e.preventDefault()
      }
    },
    onTextFieldChange (e) {
      let num = Number(e) || this.year
      this.year = 0
      this.$nextTick(() => {
        this.year = num
      })
    },
    init () {
      if (this.value == null) {
        this.year = new Date().getFullYear()
      }
    }
  },
  created () {
    this.init()
  }
}
</script>

<style lang="scss">
  .year-picker-menu {
    .v-text-field {
      input {
        text-align: right;
      }
    }
  }

  .year-picker-menu-content {

    .year-picker {

      .v-date-picker-title__date {
        display: none;
      }

      .v-date-picker-title__year {
        font-size: 34px;
        text-align: center;
        font-weight: 500;
        position: relative;
        overflow: hidden;
        padding-bottom: 8px;
        margin-bottom: -8px;
      }
    }
  }
</style>
